import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	token: 'f09e99df-de0c-456c-ac04-ceb6b39a005c',
	culture: {
		base: 'Default',
		default: 'en-GB',
	},
	core: {
		serviceUrl: 'https://api-rel.fundpress.io',
		skeletonLoaders: {
			variables: [
				{
					key: 'fillColor',
					value: '#dddddd',
				},
			],
			loaders: [
				{
					id: 'ksys-app-start',
					breakpoints: [
						{
							minWidthInPixels: 0,
							style: {
								height: '86px',
							},
							children: [
								{
									'fill': '{fillColor}',
									'x': '0px',
									'y': '11.90625px',
									'height': '28px',
									'width': '100%',
								},
								{
									'fill': '{fillColor}',
									'x': '0px',
									'y': '59.8125px',
									'height': '18px',
									'width': '100%',
								},
							],
						},
					],
				},
			],
		},
	},
	data: {
		source: {
			type: 'entityByType',
			entityType: 'CLSS',
			queryOptionsType: 'allocations',
			code: 'why_we_own',
		},
		context: {
			entityByType: {
				CLSS: {
					clientCodeProperty: 'isin',
					inputKey: 'clientCode',
					include: {
						allocations: {
							limitTo: ['why_we_own'],
						},
					},
				},
			},
		},
	},
	components: {
		app: {
			noDataOptions: {
				hide: false,
			},
			headingProps: {
				title: 'Why We Own',
			},
			globalRedirectButtonProps: {
				redirect: {
					defaultUrl: '',
					options: {
						target: '_blank',
					},
				},
			},
			gridDisplayOptions: {
				props: {
					cardsPerRow: 3,
					initialCardCount: 3,
				},
			},
			redirects: [
				{
					id: 'company',
					payloadQuery: {
						fields: [
							{
								name: 'ticker',
								query: {
									queryOptionsType: 'response',
									key: 'ticker',
								},
							},
						],
						queryOptionsType: 'object',
					},
					redirect: {
						defaultUrl: '/company/{ticker}',
						options: {
							target: '_blank',
						},
					},
				},
			],
		},
		factList: {
			factListProps: {
				props: {
					items: [
						{
							title: 'Nav',
						},
					],
				},
				queries: {
					items: [
						{
							value: {
								queryOptionsType: 'response',
								key: 'value',
								format: {
									type: 'number',
								},
							},
						},
					],
				},
			},
		},
		fundCard: {
			gridProps: {
				breakpoints: [
					{
						size: 'xsmall',
						modifier: 'up',
						props: {
							grid: {
								rows: [
									{
										columns: [
											{
												components: [
													{
														key: 'components.documentImage',
														props: {
															identifierType: 'filename',
														},
														queries: {
															identifierValue: {
																queryOptionsType: 'response',
																key: 'image',
															},
														},
													},
													{
														key: 'components.documentImage',
														props: {
															identifierType: 'filename',
														},
														queries: {
															identifierValue: {
																queryOptionsType: 'response',
																key: 'logo',
															},
															alt: {
																queryOptionsType: 'response',
																key: 'label',
															},
														},
													},
													{
														key: 'base.heading',
														props: {
															level: 2,
														},
														queries: {
															title: {
																queryOptionsType: 'response',
																key: 'label',
															},
														},
													},
													{
														key: 'components.definitionList',
													},
													{
														key: 'components.factList',
													},
													{
														key: 'components.summaryBlocks',
													},
													{
														key: 'base.text',
														props: {
															toggleState: 'collapsed',
															collapse: {
																maxLength: 119,
																suffix: '...',
															},
														},
														queries: {
															value: {
																queryOptionsType: 'response',
																key: 'description',
															},
														},
													},
													{
														key: 'components.redirectButton',
														props: {
															childProps: {
																text: 'Visit company page',
															},
															redirectId: 'company',
														},
													},
												],
											},
										],
									},
								],
							},
						},
					},
				],
			},
		},
		documentImage: {},
		summaryBlocks: {
			summaryBlocksProps: {
				props: {
					breakpoints: [
						{
							modifier: 'up',
							props: {
								itemsPerRow: 2,
							},
							size: 'xsmall',
						},
					],
					blocks: [
						{ title: 'Ticker' },
						{ title: 'NAV' },
						{ title: 'Morningstar Rating', dataType: 'morningstar-rating', weight: 2, morningstarRatingProps: { morningStarRating: 3 } },
					],
				},
				queries: {
					blocks: [
						{
							value: {
								queryOptionsType: 'response',
								key: 'ticker',
							},
						},
						{
							value: {
								queryOptionsType: 'response',
								key: 'value',
								format: {
									type: 'number',
								},
							},
						},
					],
				},
			},
		},
	},
	assetOverrides: {
		baseUrl: '',
		base: {
			carousel: {
				navLeft: 'CarouselNavArrowLeftIcon.svg',
				navRight: 'CarouselNavArrowRightIcon.svg',
			},
		},
	},
};
